module.exports = __webpack_public_path__ + "img/member_center.2405777d.svg";